import { onMounted, onBeforeUnmount } from "vue";
import { getSocket } from "@/utils/socket";

export function useDialerSocketListeners(callbacks: {
  onNextCall?: (data: any) => void;
  onCallConnected?: (data: any) => void;
  onWrapupNeeded?: (data: any) => void;
  onAutoSkipped?: (data: any) => void;
}) {
  let socket: any = null;

  onMounted(() => {
    socket = getSocket();

    if (callbacks.onNextCall) {
      socket.on("dialer:next_call", callbacks.onNextCall);
    }
    if (callbacks.onCallConnected) {
      socket.on("dialer:call_connected", callbacks.onCallConnected);
    }
    if (callbacks.onWrapupNeeded) {
      socket.on("dialer:wrapup_needed", callbacks.onWrapupNeeded);
    }
    if (callbacks.onAutoSkipped) {
      socket.on("dialer:auto_skipped", callbacks.onAutoSkipped);
    }
  });

  onBeforeUnmount(() => {
    if (!socket) return;
    if (callbacks.onNextCall) {
      socket.off("dialer:next_call", callbacks.onNextCall);
    }
    if (callbacks.onCallConnected) {
      socket.off("dialer:call_connected", callbacks.onCallConnected);
    }
    if (callbacks.onWrapupNeeded) {
      socket.off("dialer:wrapup_needed", callbacks.onWrapupNeeded);
    }
    if (callbacks.onAutoSkipped) {
      socket.off("dialer:auto_skipped", callbacks.onAutoSkipped);
    }
  });
}
